<template>
	<div class="logo" v-bind:class="size">
		<div class="logo-circle"><img src="@/assets/logo.png"></div>
		<div class="title" v-if="showTitle">Bilan Patient</div>
	</div>
</template>

<script>
export default {
	name: 'Logo',
	props: {
		size: {
			type: String,
			default: 'default',
			validator: function (value) {
				return ['default', 'medium', 'small', 'mini'].indexOf(value) !== -1
			}
		},
		showTitle: {
			type: Boolean,
			default: true
    	}
	}
};
</script>

<style scoped>

.logo {
	display: inline-block;
	text-align: center;
}

.logo-circle {
	display: inline-block;
	border-radius: 50%;
	background-color: #d9e6f2;
	border: 1px solid #c6d9eb;
}

.default .logo-circle {
	height: 168px;
}

.medium .logo-circle {
	height: 126px;
}

.small .logo-circle {
	height: 84px;
}

.mini .logo-circle {
	height: 42px;
}

.default .logo-circle img {
	width: 128px;
	height: 128px;
	margin: 20px;
}

.medium .logo-circle img {
	width: 96px;
	height: 96px;
	margin: 15px;
}

.small .logo-circle img {
	width: 64px;
	height: 64px;
	margin: 10px;
}

.mini .logo-circle img {
	width: 32px;
	height: 32px;
	margin: 5px;
}

.logo-circle img:hover {
	transition: all 0.5s ease;
	transform: rotate(15deg);
}

.title {
	color: #264d73;
	font-weight: 600;
}

.default .title {
	font-size: 28px;
}

.medium .title {
	font-size: 24px;
}

.small .title {
	font-size: 20px;
}

.mini .title {
	font-size: 14px;
}

</style>
